import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  root: {
    display: 'inline-flex',
  },
  connector: {
    margin: '0 18px',
  },
  step: {
    padding: 0,
  },
  minusConnector: {
    width: '12px',
    height: '2px',
    margin: '0 12px',
  },
});
